import { List } from 'antd';
import styled, { useTheme } from 'styled-components';
import useTestAddTestItemSelectListController from '../../../1_application/test/testAddTestItemSelectListController';
import { TestCategory, TestItemSummary } from '../../../2_domain/test/test';
import { SearchControlBoxContainer } from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXRefreshButton from '../../core/components/buttons/lxRefreshButton';
import LXTestCategorySelector from '../../core/components/buttons/lxTestCategorySelector';
import LXList from '../../core/components/list/lx_list';
import LXSearcher from '../../core/texts/lxSearcher';
import { LXbody, LXCaption, LXh4 } from '../../core/texts/lxText';
import { toIDPrice } from '../../../lib/util/numberFormatter';
import { ReactComponent as On } from '../../../assets/icons/checkBoxOn.svg';
import { ReactComponent as Off } from '../../../assets/icons/checkBoxOff.svg';
import useTestDetailDialogController from '../../../1_application/test/testDetailDialogController';

interface TestAddTestItemSelectListProps {
  testItems: TestItemSummary[];
  testCategories: TestCategory[];
  addTestItem: (testItem: TestItemSummary) => void;
  removeTestItem: (testItem: TestItemSummary) => void;
}

const HeaderPadding = styled.div`
  padding: 0px 10px 0px 56px;
`;

const ItemPadding = styled.div`
  padding: 20px 10px 20px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryBg};
  }
`;

const TestAddTestItemSelectList = (props: TestAddTestItemSelectListProps) => {
  const theme = useTheme();
  const c = useTestAddTestItemSelectListController(
    props.testItems,
    props.addTestItem,
    props.removeTestItem
  );
  const d = useTestDetailDialogController();

  const header = (
    <Column>
      <LXh4>{theme.texts.selectTestItem}</LXh4>
      <SizedBox height={4}></SizedBox>
      <LXbody color={theme.colors.caption}>
        {theme.texts.pleaseSelectTestItems}
      </LXbody>
    </Column>
  );

  const listHeader = (
    <HeaderPadding>
      <Row alignItems="center">
        <LXCaption width={'24px'}>{theme.texts.no}</LXCaption>
        <SizedBox width={16}></SizedBox>
        {/* <LXCaption width={'60px'}>{theme.texts.testCode}</LXCaption>
        <SizedBox width={16}></SizedBox> */}
        <LXCaption width={'180px'}>{theme.texts.testName}</LXCaption>
        <LXCaption width={'70px'}>{theme.texts.specimen}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'104px'}>{theme.texts.price}</LXCaption>
        <SizedBox width={16}></SizedBox>
        <LXCaption width={'80px'}>{theme.texts.requiredDay}</LXCaption>
      </Row>
    </HeaderPadding>
  );

  const listItemBuilder = (testItem: TestItemSummary, idx: number) => {
    return (
      <List.Item>
        <ItemPadding onClick={() => c.toggleItem(testItem)}>
          <Row alignItems="left">
            {c.isSelected(testItem) ? <On></On> : <Off></Off>}
            <SizedBox width={24}></SizedBox>
            <LXbody width={'24px'}> {idx + 1}</LXbody>
            <SizedBox width={16}></SizedBox>
            {/* <LXbody width={'60px'}>{testItem.serial}</LXbody>
            <SizedBox width={16}></SizedBox> */}
            <LXbody
              hoverEffect="underline"
              onClick={(e) => {
                e.stopPropagation();
                d.openDetailDialog(testItem.serial);
              }}
              width={'180px'}
            >
              {testItem.name}
            </LXbody>
            <LXbody width={'70px'}>{testItem.specimen}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'104px'}>{toIDPrice(testItem.amount, true)}</LXbody>
            <SizedBox width={16}></SizedBox>
            <LXbody width={'80px'}>{`${testItem.requiredDays} ${
              testItem.requiredDays === 1 ? theme.texts.day : theme.texts.days
            }`}</LXbody>
          </Row>
        </ItemPadding>
      </List.Item>
    );
  };

  return (
    <Column>
      {header}
      <SizedBox height={30}></SizedBox>
      <SearchControlBoxContainer width="none">
        <Row>
          <LXSearcher
            value={c.searchText}
            onChange={c.setSearchText}
            width={220}
            placeholder={theme.texts.keywordSearch}
          ></LXSearcher>
          <SizedBox width={16}></SizedBox>
          <LXTestCategorySelector
            placeholder={theme.test.category}
            testCategories={props.testCategories}
            value={c.selectedCategory}
            onSelect={c.setSelectedCategory}
          ></LXTestCategorySelector>
          <SizedBox width={132}></SizedBox>
          <LXRefreshButton onClick={c.onReset}></LXRefreshButton>
        </Row>
      </SearchControlBoxContainer>
      <SizedBox height={40}></SizedBox>
      <div className="ant-list-no-padding">
        <LXList<TestItemSummary>
          datas={c.baseTestItems}
          header={listHeader}
          itemBuilder={listItemBuilder}
          loading={c.isLoading}
        ></LXList>
      </div>
    </Column>
  );
};

export default TestAddTestItemSelectList;
